import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { TitleWidgetComponent } from "src/app/shared/components/heading-widget/title-widget/title-widget.component";
import { SummaryAutoCompleteComponent } from "src/app/shared/components/summary/components/summary-auto-complete/summary-auto-complete.component";
import { FormatType, SummaryModel } from "src/app/shared/components/summary/model/summary.model";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { MaterialModule } from "src/app/shared/module/material.module";

export class VehiclesDTO {
  id_contract: number;
  plate: string;
  valid_from: string;
}

@Component({
  selector: "ald-plate-choose",
  templateUrl: "./plate-choose.component.html",
  styleUrls: ["./plate-choose.component.scss"],
  standalone: true,
  imports: [
    TitleWidgetComponent,
    MaterialModule,
    ReactiveFormsModule,
    SummaryAutoCompleteComponent,
    I18nPipe,
    CommonModule
  ]
})
export class PlateChooseComponent extends BaseComponent implements OnInit, AfterViewInit {
  closable = false;
  listPlates = [];
  plateToReturn = null;
  plateSelected;

  summary: SummaryModel = {
    label: "plate",
    formatType: FormatType.AUTO_COMPLETE,
    techname: "plate",
    validators: [Validators.required]
  };
  form: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    public dialogRef: MatDialogRef<PlateChooseComponent>,
    public authService: RfAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: {closable: boolean, vehicles: VehiclesDTO[] }
  ) {
    super();
    this.dialogRef.disableClose = true;
  }


  ngAfterViewInit(): void {
    this.form.get('plate').valueChanges.pipe(
      tap((plate) => {
        this.plateToReturn = this.data.vehicles.filter(
          (vehicle) => vehicle.plate === plate
        );
      }),
      catchError((e,c) => {
        console.log('error value changes: ', e);
        return of(null)
      })
    ).subscribe();
  }

  ngOnInit(): void {    
    const listPlate = this.data.vehicles.map((role) => {return {value: role.plate, label: role.plate}});
    if (listPlate.constructor.name === "Array") {
      this.listPlates = listPlate;
    } else {
      this.listPlates.push(listPlate);
    }

    this.checkIfOnePlate(listPlate);
    this.closable = this.data.closable;

    this.summary.value = this.plateSelected;
    this.summary.child = this.listPlates;

    if(this.listPlates.length === 1){
      this.form.addControl('plate', new UntypedFormControl(this.plateSelected, Validators.required));
      this.form.disable();
    }
  }

  checkIfOnePlate(listPlate): void {
    this.plateSelected = this.listPlates.length === 1 ? this.listPlates[0].value : listPlate.constructor.name === "Array" ? null : "No content";
    this.plateToReturn = !!this.plateSelected ? this.plateSelected.value : null;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.plateToReturn);
  }
}
